import { addStyle } from 'dom-helper';
import iFrameBuilder from './iframe-builder';
import PathHelper from './path-helper';
import ENV from '../config/env';

import POSTER_BRICK_VERSION from '../../../gwi-brick/src/config/version';

export default class PosterIframeBuilder extends iFrameBuilder {
  static getFilePath() {
    const brickPath = ENV.posterBrickPath;
    return `${PathHelper.getBrickPath(brickPath, POSTER_BRICK_VERSION)}/${ENV.brickIndexFileName}`;
  }

  static styleHolder(holder) {
    addStyle(holder, {
      height: '100%',
    });

    return holder;
  }
}



// WEBPACK FOOTER //
// ./src/utils/poster-iframe-builder.js